<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="$t('label.serviceDepartment')" >
          <j-dict-select-tag v-decorator="['parentId',validatorRules.parentId]" :triggerChange="true"
                             dictCode="sys_depart,depart_name,id,org_category='2' and del_flag='0'"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('label.farmName')"
          :hidden="false"
          hasFeedback >
          <a-input id="departName" :placeholder="$t('label.pleaseEnterTheNameOfTheFarm')" v-decorator="['departName', validatorRules.departName ]"/>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.institutionType')">
            <a-radio-group v-decorator="['orgCategory', {initialValue: '5'}]" :placeholder="$t('label.pleaseSelectTheTypeOfOrganization')">
              <a-radio value="5">养殖场</a-radio>
            </a-radio-group>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.createABuilding')">
          <a-radio-group v-decorator="['isHouseCode', {initialValue: 'Y'}]" :placeholder="$t('label.pleaseChooseToCreateABuilding')" @change="isHouseCodeChange">
            <a-radio value="Y">是</a-radio>
            <a-radio value="N">否</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item v-show="houseCodeNumber" :label="$t('label.numberOfBuildings')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['houseCodeNumber',form.getFieldsValue(['isHouseCode']).isHouseCode == 'Y' ? validatorRules.houseCodeNumber : {}]"  :placeholder="$t('label.pleaseEnterTheNumberOfBuildings')" style="width: 100%" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.createWarehouse')">
          <a-radio-group v-decorator="['isWareHouse', {initialValue: 'Y'}]" :placeholder="$t('label.pleaseChooseToCreateAWarehouse')">
            <a-radio value="Y">是</a-radio>
            <a-radio value="N">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('label.permissionAssignment')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-multi-select-tag
            v-decorator="['userId', validatorRules.userId]"
            :options="userIdList"
            :placeholder="$t('label.pleaseSelectUser')"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import { queryIdTree,getAllUserList} from '@/api/api'
  import pick from 'lodash.pick'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import { getAction } from '@/api/manage'

  export default {
    name: "SysDepartModal",
    components: { ATextarea },
    data () {
      return {
        departTree:[],
        orgTypeData:[],
        phoneWarning:'',
        departName:"",
        title:"操作",
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {},
        menuhidden:false,
        menuusing:true,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
        departName:{rules: [{ required: true, message: '请输入农场名称!' }]},
        parentId:{rules: [{ required: true, message: this.$t('label.pleaseSelectTheServiceDepartment') }]},
        houseCodeNumber:{rules: [{ required: true, message: '请输入栋舍数!' }]},
        userId:{rules: [{ required: true, message: '请选择用户!' }]},
        },
        url: {
          add: "/farmerArchive/efsMdFarmer/addFarm",
          userList:"/farmerArchive/efsMdFarmer/queryUserList",
        },
        dictDisabled:true,
        leaderList: [], //负责人
        assignerList: [],  //分管领导
        houseCodeNumber: true,
        userIdList:[],
      }
    },
    created () {
    },
    methods: {
      add (depart) {
        this.form.resetFields()
        this.edit(depart);
        getAction(this.url.userList).then((res) => {
            if (res.success) {
                this.userIdList =  res.result
            }
        });
      },
      edit (record) {
          this.model = Object.assign({}, record);
          this.visible = true;
      },
      close () {
        const that = this;
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let obj = {
                farmerCode: this.model.code
            }
            let formData = Object.assign(obj, values);
            //时间格式化
            httpAction(this.url.add,formData,"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.form.resetFields()
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      isHouseCodeChange(enent){
         if(enent.target.value=="Y"){
             this.houseCodeNumber=true;
         }else{
             this.houseCodeNumber=false;
         }
      }
    }
  }
</script>

<style scoped>

</style>